document.addEventListener('DOMContentLoaded', function () {
    var searchInput = document.querySelector('.header-custom__search-input');
    if (!searchInput) return;

    var phrases = [
        'Search by SKU',
        'Search by name',
    ];

    var phraseIndex = 0;
    var charIndex = 0;
    var isDeleting = false;
    var timer = null;
    var isFakeTyping = false;

    function clearTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }

    function setFakeValue(text) {
        isFakeTyping = true;
        searchInput.value = text;
        searchInput.classList.add('xcloud-fake-typing');
    }

    function clearFakeValue() {
        if (!isFakeTyping) return;

        isFakeTyping = false;
        searchInput.value = '';
        searchInput.classList.remove('xcloud-fake-typing');
    }

    function hardClearFakeValue() {
        clearTimer();
        clearFakeValue();

        setTimeout(function () {
            if (searchInput.classList.contains('xcloud-fake-typing') || isFakeTyping) {
                isFakeTyping = false;
                searchInput.value = '';
                searchInput.classList.remove('xcloud-fake-typing');
            } else if (document.activeElement === searchInput && phrases.includes(searchInput.value)) {
                searchInput.value = '';
            }
        }, 0);
    }

    function isActuallyEmpty() {
        return searchInput.value.trim() === '' || isFakeTyping;
    }

    function typeLoop() {
        clearTimer();

        if (document.activeElement === searchInput) return;
        if (!isActuallyEmpty()) return;

        var current = phrases[phraseIndex];

        charIndex++;
        setFakeValue(current.substring(0, charIndex));

        if (charIndex < current.length) {
            timer = setTimeout(typeLoop, 80);
        } else {
            timer = setTimeout(function () {
                setFakeValue('');
                phraseIndex = (phraseIndex + 1) % phrases.length;
                charIndex = 0;
                timer = setTimeout(typeLoop, 250);
            }, 1400);
        }
    }

    searchInput.addEventListener('mousedown', hardClearFakeValue);
    searchInput.addEventListener('click', hardClearFakeValue);
    searchInput.addEventListener('focus', hardClearFakeValue);
    searchInput.addEventListener('touchstart', hardClearFakeValue);

    searchInput.addEventListener('blur', function () {
        if (searchInput.value.trim() === '') {
            charIndex = 0;
            typeLoop();
        }
    });

    searchInput.addEventListener('input', function () {
        if (isFakeTyping) return;
        clearTimer();
        searchInput.classList.remove('xcloud-fake-typing');
    });

    if (searchInput.value.trim() === '') {
        typeLoop();
    }
});